import { useState, useCallback, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { KPI_MODAL_VALUES, type KPILocationValue } from '../constants';
import { checkModalUrl, removeModalFromUrl } from './utils';

export function useCreateKpiModalListener() {
  const { search } = useLocation();

  const [isOpen, setIsOpen] = useState(false);
  const [teamId, setTeamId] = useState<string | null>(null);
  const [location, setLocation] = useState<KPILocationValue | null>(null);

  const checkUrl = useCallback(() => {
    const {
      isOpen: isOpenUrl,
      teamId: urlTeamId,
      location: urlLocation,
    } = checkModalUrl(KPI_MODAL_VALUES.CREATE);

    setIsOpen(isOpenUrl);
    setTeamId(urlTeamId);
    setLocation(urlLocation);
  }, []);

  // Update URL silently without triggering React Router, otherwise
  // it causes pages to 're-render' and that's not what we want
  const handleClose = useCallback(() => {
    removeModalFromUrl();

    setIsOpen(false);
  }, []);

  useEffect(() => {
    checkUrl();

    window.addEventListener('popstate', checkUrl);

    return () => {
      window.removeEventListener('popstate', checkUrl);
    };
  }, [search, checkUrl]);

  return {
    isOpen,
    teamId,
    location,
    handleClose,
  };
}
